(function () {
    "use strict";

    function ready() {
        document.querySelectorAll(".tlst-category-badge[data-category]").forEach(function (badge) {
            var label = (badge.getAttribute("data-category") || "T").trim();
            badge.textContent = label.charAt(0) || "T";
        });

        var menu = document.getElementById("tlst-menu");
        var openers = document.querySelectorAll("[data-menu-open]");
        var closer = document.querySelector("[data-menu-close]");
        var previousFocus = null;

        function setMenu(open) {
            if (!menu) return;
            menu.classList.toggle("is-open", open);
            menu.setAttribute("aria-hidden", open ? "false" : "true");
            document.body.classList.toggle("is-tlst-menu-open", open);
            document.body.style.overflow = open ? "hidden" : "";
            openers.forEach(function (button) {
                button.setAttribute("aria-expanded", open ? "true" : "false");
            });
            if (open) {
                previousFocus = document.activeElement;
                if (closer) closer.focus();
            } else if (previousFocus && previousFocus.focus) {
                previousFocus.focus();
            }
        }

        openers.forEach(function (button) {
            button.addEventListener("click", function () { setMenu(true); });
        });
        if (closer) closer.addEventListener("click", function () { setMenu(false); });
        document.addEventListener("keydown", function (event) {
            if (event.key === "Escape") setMenu(false);
        });

        document.querySelectorAll(".tlst-menu__links a").forEach(function (link) {
            if (link.querySelector(".tlst-menu__letter")) return;
            var label = link.textContent.trim();
            var labelNode = link.querySelector("span");

            if (!labelNode) {
                labelNode = document.createElement("span");
                labelNode.textContent = label;
                link.replaceChildren(labelNode);
            }

            var letter = document.createElement("i");
            letter.className = "tlst-menu__letter";
            letter.setAttribute("aria-hidden", "true");
            letter.textContent = (label.charAt(0) || "T").toUpperCase();
            link.appendChild(letter);
        });

        var scrollHeader = document.querySelector("[data-scroll-header]");
        var readingProgress = document.querySelector("[data-reading-progress]");
        var readingStats = document.querySelector("[data-reading-stats]");
        var readingTarget = document.querySelector(".tlst-article-page article, .tlst-page article");
        var refreshReadingUi = function () {};

        function reactionEnding(count) {
            var mod100 = count % 100;
            var mod10 = count % 10;
            if (mod100 >= 11 && mod100 <= 19) return "реакций";
            if (mod10 === 1) return "реакция";
            if (mod10 >= 2 && mod10 <= 4) return "реакции";
            return "реакций";
        }

        function commentEnding(count) {
            var mod100 = count % 100;
            var mod10 = count % 10;
            if (mod100 >= 11 && mod100 <= 19) return "комментариев";
            if (mod10 === 1) return "комментарий";
            if (mod10 >= 2 && mod10 <= 4) return "комментария";
            return "комментариев";
        }

        function safeTolstoyMediaUrl(value) {
            if (!value) return "";
            try {
                var parsed = new URL(value, window.location.href);
                if (parsed.protocol !== "https:") return "";
                if (parsed.hostname !== "tolstoycomments.com" && !parsed.hostname.endsWith(".tolstoycomments.com")) return "";
                return parsed.toString();
            } catch (error) {
                return "";
            }
        }

        function plainCommentText(value) {
            if (!value) return "";
            var source = String(value)
                .replace(/<br\s*\/?\s*>/gi, " ")
                .replace(/<\/(?:p|div|li)>/gi, " ");
            var template = document.createElement("template");
            template.innerHTML = source;
            return (template.content.textContent || "").replace(/\s+/g, " ").trim();
        }

        function bestCommentMedia(comment) {
            var attaches = comment && Array.isArray(comment.attaches) ? comment.attaches : [];
            var result = null;

            attaches.some(function (attachment) {
                var item = attachment && Array.isArray(attachment.data) ? attachment.data[0] : null;
                if (!item) return false;

                if (attachment.type === "images") {
                    var imageUrl = safeTolstoyMediaUrl(item.src || item.src_o);
                    if (!imageUrl) return false;
                    result = {
                        type: "image",
                        src: imageUrl,
                        width: Number(item.width) || 0,
                        height: Number(item.height) || 0,
                        count: attachment.data.length
                    };
                    return true;
                }

                if (attachment.type === "giffy") {
                    var videoUrl = safeTolstoyMediaUrl(item.video);
                    var posterUrl = safeTolstoyMediaUrl(item.src || item.webp);
                    var webpUrl = safeTolstoyMediaUrl(item.webp || item.src);
                    if (!videoUrl && !webpUrl && !posterUrl) return false;
                    result = {
                        type: "giffy",
                        video: videoUrl,
                        poster: posterUrl,
                        fallback: webpUrl || posterUrl,
                        width: Number(item.width) || 0,
                        height: Number(item.height) || 0
                    };
                    return true;
                }

                return false;
            });

            return result;
        }

        function renderBestComment(comment, count) {
            if (!readingStats) return;
            var block = readingStats.querySelector("[data-best-comment]");
            if (!block) return;

            var rating = Number(comment && comment.raiting && comment.raiting.val);
            var text = plainCommentText(comment && comment.text_template);
            var mediaData = bestCommentMedia(comment);
            if (!(count > 2 && rating > 0) || (!text && !mediaData)) {
                block.hidden = true;
                block.classList.remove("is-ready");
                return;
            }

            var author = plainCommentText(comment && comment.user && (comment.user.name || comment.user.nick)) || "Читатель";
            var ratingNode = block.querySelector("[data-best-comment-rating]");
            var authorNode = block.querySelector("[data-best-comment-author]");
            var avatar = block.querySelector("[data-best-comment-avatar]");
            var initial = block.querySelector("[data-best-comment-initial]");
            var textNode = block.querySelector("[data-best-comment-text]");
            var mediaNode = block.querySelector("[data-best-comment-media]");
            var avatarUrl = safeTolstoyMediaUrl(comment && comment.user && comment.user.ava);

            ratingNode.textContent = "+" + rating;
            authorNode.textContent = author;
            textNode.textContent = text;
            textNode.hidden = !text;
            initial.textContent = (author.charAt(0) || "Ч").toUpperCase();
            avatar.hidden = !avatarUrl;
            initial.hidden = Boolean(avatarUrl);
            if (avatarUrl) avatar.src = avatarUrl;

            mediaNode.replaceChildren();
            mediaNode.hidden = !mediaData;
            if (mediaData) {
                var mediaElement;
                var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
                if (mediaData.type === "giffy" && mediaData.video && !reduceMotion) {
                    mediaElement = document.createElement("video");
                    mediaElement.src = mediaData.video;
                    if (mediaData.poster) mediaElement.poster = mediaData.poster;
                    mediaElement.autoplay = true;
                    mediaElement.loop = true;
                    mediaElement.muted = true;
                    mediaElement.playsInline = true;
                    mediaElement.preload = "metadata";
                } else {
                    mediaElement = document.createElement("img");
                    mediaElement.src = mediaData.type === "image" ? mediaData.src : mediaData.fallback;
                    mediaElement.alt = "";
                    mediaElement.loading = "lazy";
                    mediaElement.decoding = "async";
                }
                if (mediaData.width && mediaData.height) {
                    mediaElement.width = mediaData.width;
                    mediaElement.height = mediaData.height;
                }
                mediaNode.appendChild(mediaElement);

                if (mediaData.count > 1) {
                    var mediaCount = document.createElement("i");
                    mediaCount.className = "tlst-best-comment__media-count";
                    mediaCount.textContent = "+" + (mediaData.count - 1);
                    mediaNode.appendChild(mediaCount);
                }
            }

            block.setAttribute("aria-label", "Лучший комментарий, рейтинг плюс " + rating + ", автор " + author + "; перейти к обсуждению");
            block.hidden = false;
            window.requestAnimationFrame(function () {
                block.classList.add("is-ready");
                refreshReadingUi();
            });
        }

        function createReactionUuid() {
            var bytes = new Uint8Array(16);
            if (window.crypto && window.crypto.getRandomValues) {
                window.crypto.getRandomValues(bytes);
            } else {
                bytes.forEach(function (_, index) { bytes[index] = Math.floor(Math.random() * 256); });
            }
            var binary = "";
            bytes.forEach(function (byte) { binary += String.fromCharCode(byte); });
            return window.btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "").slice(0, 22);
        }

        function getReactionUuid() {
            var storageKey = "tlst-reaction-counter-uuid";
            try {
                var stored = window.localStorage.getItem(storageKey);
                if (stored && stored.length === 22) return stored;
                var created = createReactionUuid();
                window.localStorage.setItem(storageKey, created);
                return created;
            } catch (error) {
                return createReactionUuid();
            }
        }

        var lastReactionRequest = 0;

        function loadReactionCount() {
            if (!readingStats) return;
            if (Date.now() - lastReactionRequest < 1800) return;
            var output = readingStats.querySelector("[data-reaction-count]");
            var key = readingStats.getAttribute("data-reaction-key");
            var articleUrl = readingStats.getAttribute("data-reaction-url");
            if (!output || !key || !articleUrl) return;
            lastReactionRequest = Date.now();

            var endpoint = new URL("https://web.tolstoycomments.com/api/reaction/vote");
            endpoint.searchParams.set("key", key);
            endpoint.searchParams.set("siteid", "69");
            endpoint.searchParams.set("url", articleUrl);
            endpoint.searchParams.set("title", readingStats.getAttribute("data-reaction-title") || document.title);
            endpoint.searchParams.set("hash", "null");
            endpoint.searchParams.set("uuid", getReactionUuid());

            window.fetch(endpoint.toString(), {credentials: "omit"})
                .then(function (response) {
                    if (!response.ok) throw new Error("Reaction counter request failed");
                    return response.json();
                })
                .then(function (payload) {
                    var values = payload && payload.data && payload.data.values;
                    if (!Array.isArray(values)) return;
                    var count = values.reduce(function (sum, value) { return sum + (Number(value) || 0); }, 0);
                    output.textContent = count + " " + reactionEnding(count);
                    output.setAttribute("aria-label", count + " " + reactionEnding(count) + "; перейти к оценке материала");
                })
                .catch(function () {});
        }

        function loadCommentCount() {
            if (!readingStats) return;
            var output = readingStats.querySelector("[data-comment-count]");
            var articleUrl = readingStats.getAttribute("data-reaction-url");
            if (!output || !articleUrl) return;

            var endpoint = new URL("https://web.tolstoycomments.com/api/chatpage/first");
            endpoint.searchParams.set("siteid", "69");
            endpoint.searchParams.set("hash", "null");
            endpoint.searchParams.set("url", articleUrl);
            endpoint.searchParams.set("sort", "2");
            endpoint.searchParams.set("format", "0");

            window.fetch(endpoint.toString(), {credentials: "omit"})
                .then(function (response) {
                    if (!response.ok) throw new Error("Comment counter request failed");
                    return response.json();
                })
                .then(function (payload) {
                    var count = Number(payload && payload.data && payload.data.chat && payload.data.chat.count_comment_all);
                    if (!Number.isFinite(count)) return;
                    output.textContent = count + " " + commentEnding(count);
                    output.closest("a").setAttribute("aria-label", count + " " + commentEnding(count) + "; перейти к комментариям");
                    var comments = payload && payload.data && payload.data.comments;
                    var best = Array.isArray(comments) ? comments.reduce(function (winner, comment) {
                        var winnerRating = Number(winner && winner.raiting && winner.raiting.val) || 0;
                        var commentRating = Number(comment && comment.raiting && comment.raiting.val) || 0;
                        return !winner || commentRating > winnerRating ? comment : winner;
                    }, null) : null;
                    renderBestComment(best, count);
                })
                .catch(function () {});
        }

        var hasReadingStats = false;
        if (readingStats) {
            readingStats.querySelectorAll('a[href^="#"]').forEach(function (link) {
                var target = document.querySelector(link.getAttribute("href"));
                if (!target) {
                    link.hidden = true;
                    return;
                }
                hasReadingStats = true;
                link.addEventListener("click", function (event) {
                    event.preventDefault();
                    target.scrollIntoView({
                        behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
                        block: "start"
                    });
                });
            });

            if (!hasReadingStats) {
                readingStats.hidden = true;
            } else {
                loadReactionCount();
                loadCommentCount();

                var reactionRefreshTimer = 0;
                window.addEventListener("message", function (event) {
                    var reactionFrame = document.querySelector("#tolstoycomments-reaction-emoji iframe");
                    var commentFrame = document.querySelector(".tolstoycomments-feed iframe");
                    if (event.origin !== "https://web.tolstoycomments.com") return;
                    window.clearTimeout(reactionRefreshTimer);
                    if (reactionFrame && event.source === reactionFrame.contentWindow) {
                        reactionRefreshTimer = window.setTimeout(loadReactionCount, 450);
                    } else if (commentFrame && event.source === commentFrame.contentWindow) {
                        reactionRefreshTimer = window.setTimeout(loadCommentCount, 600);
                    }
                });
            }
        }

        if (scrollHeader && readingProgress && readingTarget) {
            var lastScrollY = window.scrollY;
            var scrollTicking = false;
            var readingHero = readingTarget.querySelector(".tlst-article-hero");
            var readingContent = readingTarget.querySelector(".tlst-content");
            var feedbackTarget = document.querySelector("#tc-reactions") || document.querySelector("#tc-comments");

            function updateReadingUi() {
                var currentY = Math.max(window.scrollY, 0);
                var targetTop = readingTarget.getBoundingClientRect().top + currentY;
                var targetEnd = targetTop + readingTarget.offsetHeight - window.innerHeight;
                var denominator = Math.max(targetEnd - targetTop, 1);
                var progress = Math.min(1, Math.max(0, (currentY - targetTop) / denominator));
                var isReading = currentY > Math.max(120, targetTop - 20);
                var delta = currentY - lastScrollY;

                document.documentElement.style.setProperty("--tlst-reading-progress", progress.toFixed(4));
                readingProgress.classList.toggle("is-active", isReading);

                if (!isReading || currentY < 120) {
                    scrollHeader.classList.remove("is-visible");
                } else if (delta < -5) {
                    scrollHeader.classList.add("is-visible");
                } else if (delta > 5) {
                    scrollHeader.classList.remove("is-visible");
                }

                scrollHeader.setAttribute("aria-hidden", scrollHeader.classList.contains("is-visible") ? "false" : "true");
                if (readingStats && hasReadingStats) {
                    var heroBottom = readingHero ? readingHero.getBoundingClientRect().bottom + currentY : 0;
                    var contentTop = readingContent ? readingContent.getBoundingClientRect().top + currentY : targetTop + 180;
                    var statsStart = readingHero ? heroBottom + 24 : contentTop - 96;
                    var feedbackTop = feedbackTarget ? feedbackTarget.getBoundingClientRect().top + currentY : Number.POSITIVE_INFINITY;
                    var statsTop = scrollHeader.classList.contains("is-visible") ? 91 : 20;
                    var statsEnd = currentY + statsTop + readingStats.offsetHeight + 40;
                    var showStats = isReading && currentY > statsStart && statsEnd < feedbackTop;
                    readingStats.classList.toggle("is-active", showStats);
                    readingStats.classList.toggle("is-header-visible", scrollHeader.classList.contains("is-visible"));
                    readingStats.setAttribute("aria-hidden", showStats ? "false" : "true");
                }
                lastScrollY = currentY;
                scrollTicking = false;
            }

            window.addEventListener("scroll", function () {
                if (scrollTicking) return;
                scrollTicking = true;
                window.requestAnimationFrame(updateReadingUi);
            }, {passive: true});
            window.addEventListener("resize", updateReadingUi);
            refreshReadingUi = updateReadingUi;
            updateReadingUi();
        }

        document.querySelectorAll("[data-share]").forEach(function (button) {
            button.addEventListener("click", function () {
                var payload = {title: button.getAttribute("data-title") || document.title, url: window.location.href};
                if (navigator.share) {
                    navigator.share(payload).catch(function () {});
                    return;
                }
                if (navigator.clipboard) {
                    navigator.clipboard.writeText(payload.url).then(function () {
                        var label = button.querySelector("span");
                        if (!label) return;
                        var old = label.textContent;
                        label.textContent = "Ссылка скопирована";
                        window.setTimeout(function () { label.textContent = old; }, 1800);
                    }).catch(function () {});
                }
            });
        });

        document.querySelectorAll('.tlst-content[data-numbered="true"]').forEach(function (content) {
            if (content.querySelector(".tlst-numbered-section")) return;
            var nodes = Array.prototype.slice.call(content.children);
            var fragment = document.createDocumentFragment();
            var intro = document.createElement("div");
            intro.className = "tlst-numbered-intro";
            var section = null;
            var sectionBody = null;
            var number = 0;

            nodes.forEach(function (node) {
                var isHeading = node.matches("h1, h2");
                if (isHeading) {
                    number += 1;
                    section = document.createElement("section");
                    section.className = "tlst-numbered-section";
                    section.setAttribute("aria-labelledby", "tlst-section-" + number);

                    var numeral = document.createElement("div");
                    numeral.className = "tlst-numbered-section__number";
                    numeral.setAttribute("aria-hidden", "true");
                    numeral.textContent = String(number);

                    sectionBody = document.createElement("div");
                    sectionBody.className = "tlst-numbered-section__body";
                    node.id = node.id || "tlst-section-" + number;
                    sectionBody.appendChild(node);
                    section.appendChild(numeral);
                    section.appendChild(sectionBody);
                    fragment.appendChild(section);
                } else if (sectionBody) {
                    sectionBody.appendChild(node);
                } else {
                    intro.appendChild(node);
                }
            });

            content.replaceChildren();
            if (intro.children.length) content.appendChild(intro);
            content.appendChild(fragment);
        });

        var faqItems = [];
        document.querySelectorAll(".tlst-faq-content details").forEach(function (details, index) {
            var summary = details.querySelector(":scope > summary");
            var answer = details.querySelector(":scope > div");
            if (!summary || !answer || summary.querySelector(".tlst-faq-question")) return;

            var text = summary.textContent.trim();
            var numberMatch = text.match(/^(\d+(?:\.\d+)*)\.?\s*/);
            var numberText = numberMatch ? numberMatch[1] : String(index + 1).padStart(2, "0");
            var questionText = numberMatch ? text.slice(numberMatch[0].length) : text;

            var numberNode = document.createElement("span");
            numberNode.className = "tlst-faq-number";
            numberNode.textContent = numberText;
            var questionNode = document.createElement("span");
            questionNode.className = "tlst-faq-question";
            questionNode.textContent = questionText;
            var plus = document.createElement("span");
            plus.className = "tlst-faq-plus";
            plus.setAttribute("aria-hidden", "true");
            plus.textContent = "+";

            summary.replaceChildren(numberNode, questionNode, plus);
            answer.classList.add("tlst-faq-answer");

            var answerInner = document.createElement("div");
            answerInner.className = "tlst-faq-answer__inner";
            while (answer.firstChild) answerInner.appendChild(answer.firstChild);
            answer.appendChild(answerInner);

            details.id = details.id || "faq-" + numberText.replace(/\./g, "-");
            details.style.scrollMarginTop = "110px";
            faqItems.push(details);
        });

        if (window.location.hash && /^#faq-[0-9-]+$/.test(window.location.hash)) {
            var selectedFaq = document.querySelector(window.location.hash);
            if (selectedFaq && faqItems.includes(selectedFaq)) {
                selectedFaq.open = true;
                window.requestAnimationFrame(function () {
                    selectedFaq.scrollIntoView({
                        behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
                        block: "start"
                    });
                });
            }
        }

        if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches && "IntersectionObserver" in window) {
            document.documentElement.classList.add("has-tlst-motion");
            var observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting) return;
                    entry.target.classList.add("is-visible");
                    observer.unobserve(entry.target);
                });
            }, {rootMargin: "0px 0px -8%", threshold: 0.08});
            document.querySelectorAll(".tlst-feed-card, .tlst-numbered-section, .tlst-related__list article").forEach(function (item) {
                observer.observe(item);
            });
        }
    }

    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ready);
    else ready();
}());
